const isDev = import.meta.env.DEV;

export const config = {
  apiBaseUrl: isDev
    ? 'http://localhost:8081'
    : 'https://shhs5tfo50.execute-api.eu-central-1.amazonaws.com',
};
